import { Code2, X } from 'lucide-react';
import { useState } from 'react';
import { gotoServerEditor, Inspector } from 'react-dev-inspector';

import { Button } from './ui/button';

interface InspectorDevButtonProps {
    children: React.ReactNode;
}

export function InspectorDevButton({ children }: InspectorDevButtonProps) {
    const [active, setActive] = useState(false);
    const [isVisible, setIsVisible] = useState(true);

    return (
        <Inspector
            active={active}
            onActiveChange={setActive}
            onInspectElement={params => {
                gotoServerEditor(params);
            }}
        >
            {children}
            {isVisible ? (
                <div className="fixed bottom-4 left-4 z-[9999] inline-flex shadow-md" role="group" aria-label="React component inspector">
                    <Button
                        type="button"
                        variant="secondary"
                        size="sm"
                        onClick={() => setActive(true)}
                        className="gap-1.5 rounded-r-none"
                        aria-label="Inspect React components"
                        title="Inspect React components (Ctrl+Shift+Alt+C)"
                    >
                        <Code2 className="h-4 w-4" />
                        <span className="hidden sm:inline">Inspect</span>
                    </Button>
                    <Button
                        type="button"
                        variant="secondary"
                        size="icon"
                        onClick={() => setIsVisible(false)}
                        className="w-7 rounded-l-none border-l-0"
                        aria-label="Hide Inspect button"
                        title="Hide Inspect button"
                    >
                        <X className="h-3.5 w-3.5" />
                    </Button>
                </div>
            ) : null}
        </Inspector>
    );
}
